import * as ProductoProvider from "../providers/producto-provider";
import * as GeneralRepository from "../repositories/general-repository";
import * as ProductoMapper from "../mappers/producto-mapper";

export const obtenerBeneficiosProducto = async (beneficiosAdicionales) => {
    const response = await ProductoProvider.obtenerBeneficiosProducto(beneficiosAdicionales)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            beneficios: response.entity
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerBeneficiosProducto(beneficiosAdicionales)
            } else {
                return {
                    error: response.auditResponse,
                    beneficios: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                beneficios: null
            }
        }
    }
}

export const obtenerTextosLegales = async (productos) => {
    const request = ProductoMapper.mapProductosToCodigoProductos(productos)
    const response = await ProductoProvider.obtenerTextosLegales(request)
    if(response && response.datos !== undefined && response.datos !== null) {
        return {
            error: null,
            textosLegales: response.datos
        }
    } else {
        return {
            error: response,
            textosLegales: null
        }
    }
}

export const obtenerConfiguracionProducto = async (codigoProducto, codigoSubProducto) => {
    const response = await ProductoProvider.obtenerConfiguracionProducto(codigoProducto, codigoSubProducto)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            configuracion: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerConfiguracionProducto(codigoProducto, codigoSubProducto)
            } else {
                return {
                    error: response.auditResponse,
                    configuracion: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                configuracion: null
            }
        }
    }
}

export const listarProductos = async (idSolicitudMultiple) => {
    const response = await ProductoProvider.listarProductos(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            productos: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await listarProductos(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    productos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                productos: null
            }
        }
    }
}